// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1___2207e112bb2b7e776d8","cls2":"PaperSelector-cls2___cdc0d4a162789f248fa PaperSelector-cls1___2207e112bb2b7e776d8"};